import { SpringPagination } from '../../shared/interfaces/SpringPagination';
import { apiService } from '../../shared/services/apiService';
import { PaymentIssueFilters } from '../interfaces/PaymentIssueFilters';
import { PaymentIssueInfo } from '../interfaces/PaymentIssueRowInfo';
import { PreRegisteredFilters } from '../interfaces/PreRegisteredFilters';
import { PreRegisteredInfo } from '../interfaces/PreRegisteredRowInfo';
import { UnreadScansFilters } from '../interfaces/UnreadScansFilters';
import { UnreadScansInfo } from '../interfaces/UnreadScansRowInfo';

type GetUnreadScansResponse = SpringPagination<UnreadScansInfo[]>;
type GetPaymentIssuesResponse = SpringPagination<PaymentIssueInfo[]>;
type GetPreRegisteredResponse = SpringPagination<PreRegisteredInfo[]>;

export const requiredAttentionService = {
  async getUnreadScans(params: UnreadScansFilters): Promise<GetUnreadScansResponse> {
    const response = await apiService.post(`/api/home-page/unread-scans`, params);
    return response.data;
  },

  async getPaymentIssues(params: PaymentIssueFilters): Promise<GetPaymentIssuesResponse> {
    const response = await apiService.post(`/api/home-page/payment-issue`, params);
    return response.data;
  },

  async getPreRegistered(
    params: PreRegisteredFilters,
  ): Promise<GetPreRegisteredResponse> {
    const response = await apiService.post(`/api/home-page/pre-registered`, params);
    return response.data;
  },
};
